import { useEffect, useState } from "react"

// Mobile breakpoint matches the page-shells (Contacts,
// Companies, Settings) so a component using this hook
// agrees with the shell's variant choice. Bumping the
// breakpoint here means bumping it there too — a future
// follow-up should consolidate `useViewport` from those
// shells onto this hook.
export const MOBILE_BREAKPOINT = 768

function detect(): boolean {
  if (typeof window === "undefined") return false
  return window.innerWidth < MOBILE_BREAKPOINT
}

// True when the viewport is under the mobile breakpoint.
// Listens for resize so a popover/sheet host can swap
// chrome when the user rotates a tablet or drags a desktop
// window to phone width. SSR-safe (returns false during
// hydration; the first resize tick fixes it up).
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(detect)

  useEffect(() => {
    const handle = () => setIsMobile(detect())
    handle()
    window.addEventListener("resize", handle)
    return () => window.removeEventListener("resize", handle)
  }, [])

  return isMobile
}
